// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"mk_a pz_i pz_q pz_j"};